// DEPENDENCIES ---------------------------------------------------------------- //

// import React from 'react';

import { css } from '@emotion/css';

import { useTimeline } from '@components/Timeline/Timeline/TimelineProvider';

import TimelineIndexHeader from '@components/Timeline/Timeline/TimelineIndexHeader';
import TimelineIndexBody from '@components/Timeline/Timeline/TimelineIndexBody';

// COMPONENT ---------------------------------------------------------------- //

const TimelineIndex = () => {
  const cls = useStyles();

  const { sidebarSize, zIndex } = useTimeline();

  if (!sidebarSize) return null;
  return (
    <div className={cls.timelineIndex} style={{ zIndex: zIndex + 5, flex: `0 0 ${sidebarSize}px` }}>
      <TimelineIndexHeader />
      <TimelineIndexBody />
    </div>
  );
};

// STYLES --------------------------------------------------------------------- //

const useStyles = () => ({
  timelineIndex: css`
    position: sticky;
    display: flex;
    flex-direction: column;
    left: 0;
    min-height: 100%;
  `,
});

// -------------------------------- EXPORT -------------------------------- //

export default TimelineIndex;
